import { AccessTokenData, LocalStorageAuthStorage } from '@creditornot/wolt-auth';

class LegacyFallbackAuthStorage extends LocalStorageAuthStorage {
  read() {
    const data = super.read();

    if (!data) {
      const refreshToken = localStorage.getItem('refreshToken');
      const { accessToken, expirationTime } = JSON.parse(localStorage.getItem('accessTokenData') ?? '{}');

      if (!accessToken || !refreshToken) {
        return undefined;
      }

      const accessTokenData: AccessTokenData = {
        refreshToken,
        accessToken,
        accessTokenExpiresAt: expirationTime ?? 0,
      };

      this.save(accessTokenData);

      localStorage.removeItem('refreshToken');
      localStorage.removeItem('accessTokenData');

      return accessTokenData;
    }

    return data;
  }

  clear() {
    super.clear();
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('accessTokenData');
  }
}

export const storage = new LegacyFallbackAuthStorage({ key: 'auth-data' });
